"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasWarnings = exports.hasErrors = exports.getWarnings = exports.getSequences = exports.getOptionsWithErrors = exports.getErrors = exports.findParentOption = exports.findParentGroup = exports.findParentChoice = exports.findParent = exports.findOption = exports.findGroup = exports.findChoice = void 0;
var _filter = _interopRequireDefault(require("lodash/filter"));
var _reject = _interopRequireDefault(require("lodash/reject"));
var _flatten = _interopRequireDefault(require("lodash/flatten"));
var _defaultTo = _interopRequireDefault(require("lodash/defaultTo"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _padStart = _interopRequireDefault(require("lodash/padStart"));
var getWarnings = exports.getWarnings = function getWarnings(oneOrManyOptions) {
  var opt = oneOrManyOptions;
  return Array.isArray(opt) ? (0, _flatten["default"])(opt.map(getWarnings)) : (0, _reject["default"])(opt.messages, {
    messageType: 'Error'
  });
};
var getErrors = exports.getErrors = function getErrors(oneOrManyOptions) {
  var opt = oneOrManyOptions;
  return Array.isArray(opt) ? (0, _flatten["default"])(opt.map(getErrors)) : (0, _filter["default"])(opt.messages, {
    messageType: 'Error'
  });
};
var hasWarnings = exports.hasWarnings = function hasWarnings(oneOrManyOptions) {
  return getWarnings(oneOrManyOptions).length > 0;
};
var hasErrors = exports.hasErrors = function hasErrors(oneOrManyOptions) {
  return getErrors(oneOrManyOptions).length > 0;
};
var findOption = exports.findOption = function findOption(optionId, options) {
  return options[optionId];
};
var findChoice = exports.findChoice = function findChoice(choiceId, choices) {
  return choices[choiceId];
};
var findGroup = exports.findGroup = function findGroup(groupId, groups) {
  return groups[groupId];
};
var findParentChoice = exports.findParentChoice = function findParentChoice(dependentOption, choices) {
  return choices[dependentOption.parentChoiceId];
};
var findParentOption = exports.findParentOption = function findParentOption(choice, options) {
  return options[choice.optionId];
};
var findParentGroup = exports.findParentGroup = function findParentGroup(option, groups) {
  return groups[option.parentGroupId];
};
var findParent = exports.findParent = function findParent(node, _ref) {
  var groups = _ref.groups,
    choices = _ref.choices,
    options = _ref.options;
  if ('choices' in node) {
    return findParentChoice(node, choices) // dependentOption
    || findParentGroup(node, groups); // option
  }
  if ('optionId' in node) {
    return findParentOption(node, options); // choice
  }
  return null; // group
};

// Traverses up the tree from this option/choice/group,
// returning list of each node's local sequence (ordered top to bottom).
var getSequences = exports.getSequences = function getSequences(option, _ref2) {
  var groups = _ref2.groups,
    choices = _ref2.choices,
    options = _ref2.options;
  // groups use "sequenceNumber", options use "sequence"
  var getSequence = function getSequence(node) {
    return (0, _defaultTo["default"])(node.sequence, node.sequenceNumber);
  };
  var sequences = [];

  // good old-fashioned imperative loop
  var currentNode = option;
  while (currentNode) {
    // log local sequence
    var localSequence = getSequence(currentNode);
    sequences.unshift(localSequence);

    // traverse up
    currentNode = findParent(currentNode, {
      groups: groups,
      choices: choices,
      options: options
    });
  }
  return sequences;
};
var getOptionsWithErrors = exports.getOptionsWithErrors = function getOptionsWithErrors(_ref3) {
  var groups = _ref3.groups,
    choices = _ref3.choices,
    options = _ref3.options;
  // Merge sequences into a.b.c.d... pseudo-semantic-versioning syntax for easy sorting.
  // Makes the crazy assumption that no option has over a million choices.
  var getSequenceString = function getSequenceString(option) {
    return getSequences(option, {
      groups: groups,
      choices: choices,
      options: options
    }).map(function (sequence) {
      return (0, _padStart["default"])(sequence, 7, '0');
    }).join('.');
  };
  var optionsWithErrors = options.allIds.map(function (oid) {
    return options[oid];
  }).filter(hasErrors);
  return (0, _sortBy["default"])(optionsWithErrors, getSequenceString);
};
//# sourceMappingURL=configuratorState.js.map